var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    [
      _vm.head
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.prefix.head) } }),
            _c("strong", { domProps: { innerHTML: _vm._s(_vm.head) } }),
            _c("br"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.trunk
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.prefix.trunk) } }),
            _c("strong", { domProps: { innerHTML: _vm._s(_vm.trunk) } }),
            _c("br"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.limbs
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.prefix.member) } }),
            _c("strong", { domProps: { innerHTML: _vm._s(_vm.limbs) } }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }